document.addEventListener('DOMContentLoaded', () => {
  const reviews = document.querySelectorAll('.trustpilot-widget');

  function createObserver(element) {
    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          for (let node of mutation.addedNodes) {
            if (node.tagName === 'IFRAME') {
              element.style.display = 'block';
            }
          }
        }
      }
    });

    const config = { childList: true, subtree: true };

    observer.observe(element, config);
  }

  reviews.forEach(createObserver)
})